var Transfer = require("@/common/transfer");

module.exports = new Transfer(null, "toHost", true);



//////////////////
// WEBPACK FOOTER
// ./src/js/app/common/transfer.js
// module id = 190
// module chunks = 0